import React from 'react';
import { StyledTH } from './TH.styled';
export function TH(props) {
  var style = {
    textAlign: props.textAlign,
    width: props.width
  };
  return /*#__PURE__*/React.createElement(StyledTH, {
    style: style,
    isHidden: props.hidden
  }, props.children);
}